module.exports = __webpack_public_path__ + "static/media/Venezia.3c49eb59.png";